<ng-container *ngIf="isVisible">
  <div class="oa-sticky-footer text-center">
    <button *ngFor="let item of buttonConfiguration" class="btn btn-primary btn-round " name="{{ item.name }}" (click)="onButtonClick($event, item)">
      {{ item.label }}
    </button>
  </div>
</ng-container>
